// Module
var code = "<?xml version=\"1.0\" standalone=\"no\"?> <!doctype html> <svg width=100 height=100 xmlns=http://www.w3.org/2000/svg> <circle cx=50 cy=50 r=50 fill=#0086c3 stroke=#fff stroke-width=1 /> </svg>";
// Exports
module.exports = code;